/* eslint-disable
    eqeqeq,
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { renderComponent } from '@trello/component-wrapper';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, isForceSubmitEvent, Key } from '@trello/keybindings';
import { linksFromMarkdown, markdown } from '@trello/markdown';
import { TrelloStorage } from '@trello/storage';

import { ActionView, events } from 'app/scripts/views/action/ActionView';
import { AttachLinksView as CardAttachLinksView } from 'app/scripts/views/card/AttachLinksView';
import { AttachmentViewer } from 'app/scripts/views/internal/AttachmentViewer';
import { AutoInsertionView } from 'app/scripts/views/internal/autocomplete/AutoInsertionView';
import { CompleterUtil } from 'app/scripts/views/internal/autocomplete/CompleterUtil';
import { applyMarkdownShortcuts } from 'app/scripts/views/lib/applyMarkdownShortcuts';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { Layout } from 'app/scripts/views/lib/Layout';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import {
  editComment,
  isCommentsRewriteEnabled,
  LazyEditComment,
} from 'app/src/components/Comments';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface CommentActionView {
  maxLength: number;
  preventSubmit?: (isTooLong: boolean, isEmpty: boolean) => void;
  isCommentsRewriteEnabled: boolean;
  unmountEditCommentComponent?: () => void;
}

class CommentActionView extends ActionView {
  static initClass() {
    this.prototype.events = {
      ...events,
      // @ts-expect-error TS(2322): Type '{ 'click .js-confirm-delete-action': string;... Remove this comment to see the full error message
      'click .js-confirm-delete-action': 'confirmDeleteAction',
      'click .js-edit-action': 'editAction',
      'click .js-discard-comment-edits': 'cancelEdit',
      'click .js-save-edit': 'onClickSaveEditButton',
      'keyup .js-text': 'keyAutoMention',
      'keydown .js-text': 'keydownJsText',
      'input .js-text': 'checkLength',
      'mutated .js-text': 'mutatedEvent',

      'click .js-comment-add-attachment': 'commentAddAttachment',
      'click .js-comment-mention-member': 'commentMentionMember',
      'click .js-comment-add-emoji': 'commentAddEmoji',
      'click .js-comment-add-card': 'commentAddCard',
      'click .js-attach-link': 'attachLink',
      'click .js-comment img': 'handleImageClick',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
  }

  initialize() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.initialize(...arguments);
    this.isCommentsRewriteEnabled = isCommentsRewriteEnabled();
    return $(window).on(
      `beforeunload.CommentActionView-${this.model.cid}`,
      () => this.saveDraft(),
    );
  }

  remove() {
    this.saveDraft();
    $(window).off(`.CommentActionView-${this.model.cid}`);
    this.unmountEditCommentComponent?.();
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    return super.remove(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mutatedEvent(e: any) {
    this.checkLength(e);
    this.getTextInput().trigger('autosize.resize');
  }

  potentialAttachments() {
    const card = this.model.getCard();
    return _.filter(
      linksFromMarkdown(this.model.get('data').text, markdown.comments),
      function ({ url }) {
        // Don't include URLs that are not allowed by the enterprise
        if (card.attachmentUrlRestricted(url)) {
          return false;
        }

        // Don't include things that have already been attached
        return !card.attachmentList.any(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (attachment: any) => attachment.get('url') === url,
        );
      },
    );
  }

  getContext() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    const data = super.getContext(...arguments);
    const card = this.model.getCard();
    // It's possible that comment is for a card that isn't currently cached, in
    // which case we can't attach a link to it
    data.canAttachLink =
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      card != null && card.editable() && this.potentialAttachments().length > 0;
    return data;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmDeleteAction(e: any) {
    stopPropagationAndPreventDefault(e);

    Confirm.toggle('delete comment', {
      elem: $(e.target).closest('.js-confirm-delete-action')[0],
      model: this.model,
      confirmBtnClass: 'nch-button nch-button--danger',
      fxConfirm: () => {
        const traceId = Analytics.startTask({
          taskName: 'delete-comment',
          source: 'cardDetailScreen',
        });
        return this.model.destroyWithTracing(
          {
            traceId,
          },
          tracingCallback(
            {
              taskName: 'delete-comment',
              traceId,
              source: 'cardDetailScreen',
            },
            (err) => {
              if (!err) {
                Analytics.sendTrackEvent({
                  action: 'deleted',
                  actionSubject: 'comment',
                  source: 'cardDetailScreen',
                  attributes: {
                    taskId: traceId,
                  },
                });
              }
            },
          ),
        );
      },
    });
  }

  getTextInput() {
    return $('.js-text', this.$el);
  }

  getMentionTarget() {
    return $('.js-comment-mention-member:visible', this.$el)[0];
  }

  getEmojiTarget() {
    return $('.js-comment-add-emoji:visible', this.$el)[0];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editAction(e: any) {
    stopPropagationAndPreventDefault(e);
    if (this.$el.hasClass('is-editing')) {
      return;
    }
    this.$el.addClass('is-editing');

    if (this.isCommentsRewriteEnabled) {
      this.renderEditCommentComponent();
      editComment(this.model.id);
      return;
    }

    $('textarea', this.$el).focus().select();
    return this.openEditView();
  }

  openEditView() {
    // @ts-expect-error TS(2339): Property 'autosize' does not exist on type 'JQuery... Remove this comment to see the full error message
    $('.js-text', this.$el).attr('placeholder', '').autosize({ append: false });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownJsText(e: any) {
    applyMarkdownShortcuts(e);

    if (isForceSubmitEvent(e)) {
      return this.onClickSaveEditButton(e);
    } else if (getKey(e) === Key.Escape) {
      stopPropagationAndPreventDefault(e);

      if (AttachmentViewer.isActive()) {
        AttachmentViewer.clear();
        return;
      }

      return this.cancelEdit();
    } else {
      return this.checkInsert(e);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveEdit = (newValue: any) => {
    // So that we don't have to wait for the roundtrip to display the
    // new text, which would be very scary for users.
    this.model.get('display').entities.comment.text = newValue;

    const traceId = Analytics.startTask({
      taskName: 'edit-comment',
      source: 'cardDetailScreen',
    });
    const data = {
      text: newValue,
      traceId,
    };
    this.model.update(
      data,
      tracingCallback(
        {
          taskName: 'edit-comment',
          source: 'cardDetailScreen',
          traceId,
        },
        (err, response) => {
          if (!err && response) {
            Analytics.sendTrackEvent({
              action: 'updated',
              actionSubject: 'comment',
              source: 'cardDetailScreen',
              containers: {
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                card: { id: response.data?.card?.id },
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                board: { id: response.data?.board?.id },
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                list: { id: response.data?.list?.id },
              },
              attributes: {
                taskId: traceId,
                isEditorEnabled: isCommentsRewriteEnabled(),
              },
            });
          }
        },
      ),
    );
    Layout.cancelEdit(this.$el);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClickSaveEditButton(e: any) {
    if (
      !(
        e.type !== 'keypress' ||
        // If they pressed ctrl+enter, then that's always a submit
        isForceSubmitEvent(e) ||
        // If they pressed enter, and they aren't on a multi-line textarea, that's also a submit
        (getKey(e) === Key.Enter &&
          (!$(e.target).is('textarea') ||
            $(e.currentTarget).hasClass('single-line')))
      )
    ) {
      return;
    }

    stopPropagationAndPreventDefault(e);

    const newValue = $('.js-text', this.$el).val();

    $('.js-spinner', this.$el).show();
    $('.js-hide-on-sending', this.$el).hide();

    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    $('.current-comment', this.$el).text(newValue);
    this.discardDraft();

    this.saveEdit(newValue);

    $('.js-text', this.$el).trigger('autosize.destroy');

    PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showError(e: any) {}

  cancelEdit() {
    const prevComment = this.getComment();

    if (this.isCommentsRewriteEnabled) {
      Layout.cancelEdit(this.$el);
      return;
    }

    $('.js-text', this.$el).val(prevComment);
    Layout.cancelEdit(this.$el);
    this.discardDraft();
    $('.js-text', this.$el).trigger('autosize.destroy');
  }

  getComment = () => this.model.get('data').text;

  getCard() {
    return this.model.getCard();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attachLink(e: any) {
    stopPropagationAndPreventDefault(e);

    const links = this.potentialAttachments();
    return PopOver.toggle({
      elem: $(e.currentTarget),
      view: new CardAttachLinksView({
        model: this.getCard(),
        links,
      }),
    });
  }

  render() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.render(...arguments);
    this.recallDraft();

    return this;
  }

  renderEditCommentComponent() {
    const reactRoot = this.el.querySelector('.js-edit-comment-react-root');
    // Because of Backbone hijinks, this can be rendered multiple times, but it
    // doesn't need to be, since the React component is kept fresh.
    if (reactRoot && !reactRoot.querySelector('.js-react-root')) {
      this.unmountEditCommentComponent = renderComponent(
        <LazyEditComment
          idBoard={this.model.getBoard()?.id}
          idCard={this.model.getCard()?.id}
          idComment={this.model.id}
          idOrganization={this.model.getBoard()?.get('idOrganization')}
          getComment={this.getComment}
          saveEdit={this.saveEdit}
          // eslint-disable-next-line react/jsx-no-bind
          cancelEdit={this.cancelEdit.bind(this)}
        />,
        reactRoot,
      );
    }
  }

  _draftKey() {
    return `draft_${this.model.id}_edit`;
  }

  recallDraft() {
    const draftText = TrelloStorage.get(this._draftKey());
    if (draftText) {
      this.getTextInput().val(draftText);
      return this.$el.find('.edits-warning').show();
    }
  }

  saveDraft() {
    if (this.$el.hasClass('is-editing')) {
      const text = this.getTextInput().val();

      if (text && text !== this.model.get('data').text) {
        TrelloStorage.set(this._draftKey(), text);
        this.$el.find('.edits-warning').show();
      } else {
        this.discardDraft();
      }
    }
  }

  discardDraft() {
    TrelloStorage.unset(this._draftKey());
    return this.$el.find('.edits-warning').hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkLength(e: any) {
    const text = $(e.target).val();
    const maxLength = this.maxLength || 16384;
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const isEmpty = text.length === 0 || /^\s*$/.test(text);
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const isTooLong = !isEmpty && text.length > maxLength;
    if (this.preventSubmit != null) {
      this.preventSubmit(isTooLong, isEmpty);
    } else {
      this._preventSubmit(isTooLong, isEmpty);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _preventSubmit(isTooLong: any, isEmpty: any) {
    $('.js-too-long-warning', this.$el).toggleClass('hide', !isTooLong);
    $('.js-is-empty-warning', this.$el).toggleClass('hide', !isEmpty);
    return $('input[type="submit"]', this.$el).prop(
      'disabled',
      isEmpty || isTooLong,
    );
  }

  handleImageClick(e: MouseEvent) {
    const img = $(e.target as HTMLElement).closest('img');
    const url = img.attr('src');
    const card = this.model.getCard();

    const attachment = card.attachmentList.where({ url })[0];
    if (!AttachmentViewer.isActive() && attachment) {
      stopPropagationAndPreventDefault(e);
      AttachmentViewer.show({
        model: card,
        attachmentModel: attachment,
      });
      Analytics.sendScreenEvent({
        name: 'attachmentViewerModal',
        attributes: {
          type: attachment.getType(),
        },
      });
      return;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkInsert(e: any) {
    return AutoInsertionView.checkInsert.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyAutoMention(e: any) {
    return AutoInsertionView.keyAutoMention.call(this, e);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openEmojiCompleter(e: any) {
    return CompleterUtil.openEmojiCompleter.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  autoMentionerView(source: any, card: any, board: any) {
    return CompleterUtil.autoMentionerView.call(this, source, card, board);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAutoMentionerView(source: any) {
    return CompleterUtil.getAutoMentionerView.call(this, source);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getEmojiCompleterView(source: any) {
    return CompleterUtil.getEmojiCompleterView.call(this, source);
  }
  getTrelloCompleterView() {
    return CompleterUtil.getTrelloCompleterView.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentAddAttachment(e: any) {
    return CompleterUtil.commentAddAttachment.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentMentionMember(e: any) {
    return CompleterUtil.commentMentionMember.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentAddEmoji(e: any) {
    return CompleterUtil.commentAddEmoji.call(this, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentAddCard(e: any) {
    return CompleterUtil.commentAddCard.call(this, e);
  }
}
CommentActionView.initClass();

export { CommentActionView };
